import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import vueI18n from "./vueI18n";

Vue.use(Vuetify, {
    silent: true,
    warn: false
});

export default new Vuetify({
    icons: {
        values: {
            danger: 'error'
        }
    },
    lang: {
        t: (key, ...params) => vueI18n.t(key.replace('$vuetify.', ''), params)
    },
    treeShake: true,
    defaultAssets: false,
    //customVariables: ["~/styles/variables.scss"],
    theme: {
        options: {
            customProperties: true,
        },
        defaultFont: false,
        dark: false,
        themes: {
            light: {
                lighthover: '#eeeeee',
                border: '#DDDDDD',
                base: '#fff',
                primary: '#02b3aa',
                secondary: '#093c45',
                purple: '#4A148C',
                grey: '#546E7A',
                accent: '#000',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                //warning: '#d6a100',
                danger: '#FF5252',
                loading: '#78909C',
                fire: '#FB8C00'
            },
            dark: {
                lighthover: '#616161',
                border: '#393939',
                base: '#1E1E1E',
                primary: '#02b3aa',
                secondary: '#093c45',
                purple: '#4A148C',
                grey: '#546E7A',
                accent: '#fff',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                //warning: '#d6a100',
                danger: '#FF5252',
                loading: '#78909C',
                fire: '#FB8C00'
            },
        },
    },
});
